import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Twitter, Instagram, Facebook } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-50 pt-16 pb-8 border-t border-gray-200">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-10">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10 mb-12">
          <div className="max-w-xs">
            <div className="flex items-center gap-2 mb-4">
              <div className="size-6 flex items-center justify-center overflow-hidden">
                <img
                  src="/logo/logo_bizz.png"
                  alt="BizzKonnect Logo"
                  className="h-full w-full object-contain"
                />
              </div>
              <span className="text-[#181811] text-lg font-bold">BizzKonnect</span>
            </div>
            <p className="text-sm text-gray-500">
              The #1 automated follow-up tool for small business owners. Never miss a lead again.
            </p>
          </div>

          <div className="flex flex-wrap gap-12 sm:gap-20">
            <div className="flex flex-col gap-3">
              <h4 className="font-bold text-[#181811] text-sm">Product</h4>
              <Link to="/features" className="text-sm text-gray-500 hover:text-[#f9f506] transition-colors">
                Features
              </Link>
              <Link to="/how-it-works" className="text-sm text-gray-500 hover:text-[#f9f506] transition-colors">
                How it Works
              </Link>
              <a href="#download" className="text-sm text-gray-500 hover:text-[#f9f506] transition-colors">
                Download
              </a>
            </div>

            <div className="flex flex-col gap-3">
              <h4 className="font-bold text-[#181811] text-sm">Company</h4>
              <Link to="/support" className="text-sm text-gray-500 hover:text-[#f9f506] transition-colors">
                Support
              </Link>
              <Link to="/support#contact" className="text-sm text-gray-500 hover:text-[#f9f506] transition-colors">
                Contact
              </Link>
              <Link to="/privacy" className="text-sm text-gray-500 hover:text-[#f9f506] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-gray-500 hover:text-[#f9f506] transition-colors">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-400">© 2024 BizzKonnect Inc. All rights reserved.</p>
          <div className="flex gap-4">
            <a href="#" className="text-gray-400 hover:text-[#181811] transition-colors" aria-label="Twitter">
              <Twitter className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-[#181811] transition-colors" aria-label="Instagram">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-[#181811] transition-colors" aria-label="Facebook">
              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};